import { BlockComponent } from './BlockComponent';
import { GameActionEvent } from '../../constants/GameActionEvent';

// Refers to the existed blocks

export class BlockWithActionButtonComponent extends BlockComponent {
    #buttons;
    #defaultAction;
    #contentBlockEl;

    constructor(elem) {
        super(elem);

        const el = elem.querySelector('[data-action][data-action-default="true"]');

        this._needListeners = true;
        this.#buttons = [...elem.querySelectorAll('[data-action]')];
        this.#defaultAction = el ? el.dataset.action : null;

        this.#contentBlockEl = elem.children && elem.children.length > 0 ? elem.children[0] : null;
    }

    _addListeners() {
        super._addListeners();

        if (!this.#buttons) return;

        this._clickHandler = (evt) => {
            const t = Date.now();

            // To prevent double click
            if (this._clickTimestamp && t - this._clickTimestamp < 400) return;

            let { currentTarget } = evt;
            const { target } = evt;

            currentTarget = currentTarget || target;

            if (!currentTarget) return;

            const { action } = currentTarget.dataset;

            this.dispatchEvent({
                type: GameActionEvent,
                action: {
                    type: action
                }
            });

            this._clickTimestamp = t;
        };

        this.#buttons.forEach((elem) => {
            elem.addEventListener('click', this._clickHandler);
        });

        if (this.#defaultAction) {
            this._keyboardHandler = this._keyboardHandler || ((evt) => {
                if (evt.code !== 'Space' && evt.code !== 'Enter') return;
                this.dispatchEvent({
                    type: GameActionEvent,
                    action: {
                        type: this.#defaultAction
                    }
                });
            });
            document.addEventListener('keydown', this._keyboardHandler);
        }
    }

    _removeListeners() {
        super._removeListeners();

        if (this._keyboardHandler) document.removeEventListener('keydown', this._keyboardHandler);

        if (!this.#buttons || !this._clickHandler) return;

        this.#buttons.forEach((elem) => {
            elem.removeEventListener('click', this._clickHandler);
        });
    }

    _clear() {
        super._clear();

        this.#buttons = null;
    }

    getSyncBoundingRect() {
        return this.#contentBlockEl ? this.#contentBlockEl.getBoundingClientRect() : null;
    }
}
